// Policy — a named, versioned, reusable bundle of constraint
// memberships. "A filter a material passes through"
// (`docs/model/constraints.md` §Policy).
//
// A Policy is strictly more expressive than the dead authority enum for
// two reasons the model spells out:
//   - **Severity is per-membership.** The SAME constraint can be a
//     member of several policies with DIFFERENT severity in each. Force
//     is a property of the membership, not of the constraint.
//   - **Constraints are shared, policies are named.** One constraint
//     belongs to many policies; a policy is a named artifact you version,
//     ship, and reason about as a unit.
//
// Lifecycle (`docs/model/constraints.md` §Policy lifecycle): a Policy is
// `{ id, version, members }` and every reference to it carries the
// version, never just the id — a version, once attested against, is
// immutable; a deliberate edit publishes a NEW version. This module
// owns the shape; the attestation-pinning event substrate is a later
// integrator stitch (see the BC composer header).
//
// Pure module.
export { from, mk, mkMember, mkPolicy, to };
import { mkParser } from "../_ids/parse.js";
const mk = (s) => s;
const to = mkParser("PolicyId", mk);
const from = (id) => id;
const mkMember = (constraint, severity) => ({ constraint, severity });
const mkPolicy = (id, version, members) => ({ id, version, members });
//# sourceMappingURL=policy.js.map